/* "Look inside the book" sheet (snippets/ec-look-inside.liquid). Built Sep 28 2026.
   Opens a native <dialog> (top layer, so no theme transform or z-index can trap it), loads the
   page pictures only on first open, counts pages as the reader scrolls, and sends Clarity
   look_inside_open, look_inside_end (reached the blurred pages) and look_inside_get. */
(function () {
  'use strict';

  function track(name) {
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
  }

  function init(root) {
    if (!root || root.__ecli) return;
    var btn = root.querySelector('[data-ecli-open]');
    var dlg = root.querySelector('[data-ecli-dialog]');
    if (!btn || !dlg) return;
    root.__ecli = true;

    var body = dlg.querySelector('[data-ecli-body]');
    var count = dlg.querySelector('[data-ecli-count]');
    var prog = dlg.querySelector('[data-ecli-prog]');
    var locked = dlg.querySelector('[data-ecli-locked]');
    var free = Array.prototype.slice.call(dlg.querySelectorAll('[data-ecli-free]'));
    var total = parseInt(dlg.getAttribute('data-free'), 10) || free.length;
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var loaded = false, endSent = false, closing = null;

    function load() {
      if (loaded) return;
      loaded = true;
      Array.prototype.forEach.call(dlg.querySelectorAll('img[data-src]'), function (img) {
        img.src = img.getAttribute('data-src');
      });
    }

    function update() {
      var top = body.scrollTop + 60, n = 1;
      free.forEach(function (f, i) { if (f.offsetTop <= top) n = i + 1; });
      var last = free[free.length - 1];
      var past = last && body.scrollTop + 60 > last.offsetTop + last.offsetHeight;
      var atEnd = body.scrollTop + body.clientHeight >= body.scrollHeight - 40;
      if (past || atEnd) {
        count.textContent = 'That was the free sample';
        prog.style.width = '100%';
      } else {
        count.textContent = 'Page ' + n + ' of ' + total + ' free pages';
        prog.style.width = Math.max(10, Math.round(n / total * 100)) + '%';
      }
      if (!endSent && locked && body.scrollTop + body.clientHeight > locked.offsetTop + 80) {
        endSent = true;
        track('look_inside_end');
      }
    }

    function open() {
      load();
      clearTimeout(closing);
      if (typeof dlg.showModal === 'function') {
        if (!dlg.open) dlg.showModal();
      } else {
        dlg.setAttribute('open', '');
      }
      document.documentElement.classList.add('ecli-lock');
      body.scrollTop = 0;
      endSent = false;
      update();
      void dlg.offsetWidth; /* commit the closed position so the slide-in transition runs */
      dlg.classList.add('is-in');
      track('look_inside_open');
    }

    function close(after) {
      dlg.classList.remove('is-in');
      document.documentElement.classList.remove('ecli-lock');
      closing = setTimeout(function () {
        if (dlg.open) { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
        if (after) after();
        else btn.focus();
      }, reduce ? 0 : 300);
    }

    btn.addEventListener('click', open);
    dlg.querySelector('[data-ecli-close]').addEventListener('click', function () { close(); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    body.addEventListener('scroll', update, { passive: true });

    var get = dlg.querySelector('[data-ecli-get]');
    if (get) get.addEventListener('click', function () {
      track('look_inside_get');
      close(function () {
        var box = document.querySelector('[data-ecofr]') || document.querySelector('product-form, form[action*="/cart/add"]');
        if (!box) return;
        box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        var atc = box.querySelector('.ecofr-atc, [type="submit"]');
        if (atc && atc.animate && !reduce) {
          setTimeout(function () {
            atc.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.04)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'ease-out' });
          }, 450);
        }
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ecli-root]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
